export default "__VITE_ASSET__Pa_vbl44__"